module.exports = __webpack_public_path__ + "static/img/changJingImg4.0b5886d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/changJingImg4.png
// module id = KaOF
// module chunks = 2